import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneFileService } from '../../../../projects/kiene-core/src/lib/services/files/kiene-file.service';
import { KieneTableService } from '../../components/kiene-table/kiene-table.service';
import { DateTableColumn, SlideToggleTableColumn, TableColumn } from '../../components/kiene-table/table-column';
import { TableDescriptor } from '../../components/kiene-table/table-descriptor';
import { TableOption } from '../../components/kiene-table/table-option';
import { Inventur } from '../../warehouse/inventur/entities/Inventur';
import { InventurActiceNoticeDialogComponent } from './inventur-actice-notice-dialog/inventur-actice-notice-dialog.component';
import { InventurCreateDialogComponent } from './inventur-create-dialog/inventur-create-dialog.component';
import { InventurDeleteDialogComponent } from './inventur-delete-dialog/inventur-delete-dialog.component';
import { InventurEditDialogComponent } from './inventur-edit-dialog/inventur-edit-dialog.component';
import { MessageService } from '../../../../projects/kiene-core/src/lib/services/message-service/message.service';

@Component({
    selector: 'kiene-inventur-verwaltung',
    templateUrl: './inventur-verwaltung.component.html',
    styleUrls: ['./inventur-verwaltung.component.scss'],
})
export class InventurVerwaltungComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    constructor(
        private dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private tableService: KieneTableService,
        private messageService: MessageService,
        private fileService: KieneFileService,
    ) {}

    ngOnInit(): void {
        this.tableDescriptor.headline = `Inventur - Verwaltung`;
        this.tableDescriptor.uniqueIdentifier = `Inventur - Verwaltung`;
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'inventur/';
        this.tableDescriptor.route = '/lager/inventur-verwaltung/';
        this.tableDescriptor.nameOfIdField = 'inventur_id';
        this.tableDescriptor.searchPlaceholder = 'Nach Inventurjahr durchsuchen';
        this.tableDescriptor.columns.push(new TableColumn('name', 'Name'));
        this.tableDescriptor.columns.push(new TableColumn('jahr', 'Jahr'));
        this.tableDescriptor.columns.push(new DateTableColumn('erstellt', 'Erstellt am', 'dd.MM.yy'));
        this.tableDescriptor.columns.push(
            new SlideToggleTableColumn('aktiv', 'Aktiv', this.inventurAktivSlider.bind(this)),
        );
        this.tableDescriptor.initialSortColumn = 'erstellt';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.permissionCreate = 4442;
        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = false;
        this.tableDescriptor.options.push(new TableOption(this.openEditDialog.bind(this), 'Bearbeiten', 'edit', 4442));
        this.tableDescriptor.options.push(new TableOption(this.openDeleteDialog.bind(this), 'Löschen', 'delete', 4444));
        this.tableDescriptor.options.push(
            new TableOption(this.exportAsCsv.bind(this), 'CSV Export', 'file_download', 4445),
        );
        this.tableDescriptor.addVoid = this.openCreateDialog.bind(this);
    }

    inventurAktivSlider(inventur: Inventur) {
        if (inventur.aktiv) {
            this.openNoticeDialog(inventur);
        } else {
            this.updateInventur(inventur);
        }
    }

    private exportAsCsv(inventur: Inventur) {
        const params = new HttpParams().set('inventur_id', inventur.inventur_id.toString());
        this.fileService.downloadCSV(this.apiBaseUrl + 'inventur/read_csv.php', params);
    }

    private openNoticeDialog(inventur: Inventur) {
        const dialogRef = this.dialog.open(InventurActiceNoticeDialogComponent, { data: { inventur: inventur } });
        dialogRef.afterClosed().subscribe({
            next: (setActive: boolean) => {
                if (setActive) {
                    this.updateInventur(inventur);
                } else {
                    inventur.aktiv = 0;
                }
            },
        });
    }

    private openCreateDialog() {
        const dialogRef = this.dialog.open(InventurCreateDialogComponent, { data: {} });
        dialogRef.afterClosed().subscribe({
            next: (createdInventur: Inventur) => {
                if (createdInventur) {
                    this.createNewInventur(createdInventur);
                }
            },
        });
    }

    private createNewInventur(createdInventur: Inventur) {
        this.tableService.post(this.apiBaseUrl + 'inventur/create.php', createdInventur).subscribe({
            next: () => {
                this.tableService.reload();
            },
            error: err => {
                this.messageService.errorMessage('Die Inventur konnte nicht angelegt werden!', err);
            },
        });
        return;
    }

    private openEditDialog(value: any) {
        const dialogRef = this.dialog.open(InventurEditDialogComponent, { data: { inventur: value } });
        dialogRef.afterClosed().subscribe({
            next: (inventur: Inventur) => {
                if (inventur) {
                    this.updateInventur(inventur);
                }
            },
        });
    }

    private openDeleteDialog(value: any) {
        const dialogRef = this.dialog.open(InventurDeleteDialogComponent, { data: { inventur: value } });
        dialogRef.afterClosed().subscribe({
            next: (toDelete: boolean) => {
                if (toDelete) {
                    this.deleteInventur(value);
                }
            },
        });
    }

    private updateInventur(inventur: Inventur) {
        this.tableService.updateEntity(this.apiBaseUrl + 'inventur/update.php', inventur).subscribe({
            next: () => {
                this.tableService.reload();
            },
            error: err => {
                this.messageService.errorMessage('Die Inventur konnte nicht gespeichert werden!', err);
                inventur.aktiv = 0;
            },
        });
    }

    private deleteInventur(inventur: Inventur) {
        this.tableService.deleteEntity(this.apiBaseUrl + 'inventur/delete.php', inventur).subscribe({
            next: () => {
                this.tableService.reload();
            },
            error: err => {
                this.messageService.errorMessage('Die Inventur konnte nicht gelöscht werden', err);
            },
        });
    }
}
